module.exports = __webpack_public_path__ + "img/3.182e6e79.png";